module.exports = __webpack_public_path__ + "img/Official.6b2ce574.png";